// extracted by mini-css-extract-plugin
var _1 = "OZugWSy3vZOR4TtrtAEK";
export { _1 as "events" }
